const Direction = {
  UP: 'up',
  DOWN: 'down'
}

class Stopwatch {
  constructor (data, now) {
    this._isRunning = data.isRunning
    this._currentTimeMs = data.currentTimeMs
    this._currentTimeUtc = data.currentTimeUtc
    this._startTimeMs = data.startTimeMs || 0
    this._endTimeMs = data.endTimeMs || 0

    this._direction = this._startTimeMs <= this._endTimeMs ? Direction.UP : Direction.DOWN
    this._now = now || Date.now()
  }

  get isRunning () {
    return this._isRunning
  }

  get currentTimeMs () {
    if (!this._isRunning) {
      return this._currentTimeMs
    }

    if (this._direction === Direction.UP) {
      return this._now - this._currentTimeUtc
    } else {
      return this._currentTimeUtc - this._now
    }
  }

  get elapsedMs () {
    if (this._direction === Direction.UP) {
      return this.currentTimeMs - this._startTimeMs
    } else {
      return this._startTimeMs - this.currentTimeMs
    }
  }

  get leftMs () {
    if (this._direction === Direction.UP) {
      return this._endTimeMs - this.currentTimeMs
    } else {
      return this.currentTimeMs - this._endTimeMs
    }
  }
}

export default Stopwatch



// WEBPACK FOOTER //
// ./src/lib/Stopwatch.js